import type { FC } from 'react';
import { useContext, useEffect } from 'react';

import { Preloader } from '@smartshell/ui-kit';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from 'auth';

import { IRouterAuthHOCProps, PermissionKey } from './types';

export const RouterAuthHOC: FC<IRouterAuthHOCProps> = ({
  children,
  permission,
}) => {
  const {
    data: { permissions },
  } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    if (!permissions || !permission) return;

    if (
      (Array.isArray(permission) &&
        permission.every((p) => permissions.has(p))) ||
      (permission && permissions.has(permission as PermissionKey))
    )
      return;

    navigate('/', { replace: true });
  }, [navigate, permissions, permission]);

  return <Preloader loading={!permissions}>{children}</Preloader>;
};
